import * as React from 'react';

import { cn } from '../lib/utils';

export interface LogoProps extends React.ComponentProps<'img'> {
  variant?: 'horizontal' | 'stacked';
}

/**
 * IBAS logo image.
 *
 * Brand rule: the primary horizontal lockup is the default for web; the stacked
 * lockup is for square/vertically-constrained slots only ("use sparingly").
 * Minimum legible widths are 260px (horizontal) and 170px (stacked).
 *
 * Asset files live in the host app's `public/brand/` directory, so the `src`
 * defaults to an absolute public path. Override `src` if your app serves the
 * assets elsewhere.
 */
function Logo({ variant = 'horizontal', className, alt, src, ...props }: LogoProps) {
  const defaultSrc =
    variant === 'stacked' ? '/brand/ibas-logo-stacked.png' : '/brand/ibas-logo.png';
  return (
    <img
      data-slot="logo"
      src={src ?? defaultSrc}
      alt={alt ?? 'International Business Academy of Switzerland'}
      className={cn(variant === 'stacked' ? 'h-auto w-[170px]' : 'h-auto w-[260px]', className)}
      {...props}
    />
  );
}

export { Logo };
